
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-18891.084 -24068.699 17.115 14.398"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_164_1","data-name":"Symbol 164 – 1","transform":"translate(-19906.385 -25482)","opacity":".74"}},[_c('g',{attrs:{"id":"Group_5687","data-name":"Group 5687","transform":"translate(1016 1414)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3413","d":"M3.326 0A3.326 3.326 0 1 1 0 3.326 3.326 3.326 0 0 1 3.326 0z","data-name":"Path 3413","transform":"translate(2.721)"}}),_c('path',{attrs:{"id":"Path_3407","d":"M1.481 13A1.484 1.484 0 0 1 0 11.519V10.37c0-2 2.721-3.628 6.047-3.628s6.047 1.633 6.047 3.628v1.149A1.484 1.484 0 0 1 10.613 13z","data-name":"Path 3407","stroke-miterlimit":"10","fill":"none","stroke":"#444","stroke-linecap":"round","stroke-width":"1.4"}})]),_c('g',{attrs:{"id":"Group_5682","data-name":"Group 5682","transform":"translate(1028.352 1414)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3412","d":"M4.192 2.918L6.992 0","data-name":"Path 3412","transform":"translate(-4.192 .696)"}}),_c('path',{attrs:{"id":"Path_3398","d":"M.04 0h3.325v3.482","data-name":"Path 3398","stroke-linejoin":"round","stroke-miterlimit":"10","fill":"none","stroke":"#444","stroke-linecap":"round","stroke-width":"1.4"}})])])])
          )
        }
      }
    